import { render, staticRenderFns } from "./ConfigureOAjuste.vue?vue&type=template&id=098a09fb&scoped=true"
import script from "./ConfigureOAjuste.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureOAjuste.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ConfigureOAjuste.vue?vue&type=style&index=0&id=098a09fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a09fb",
  null
  
)

export default component.exports